export const tr = {
    'phrases-cell-title': 'Sözcük grupları',
    'shows-cell-title': 'Gösterim sayısı'
};
